module.exports = __webpack_public_path__ + "img/دایره.5c6ff77e.png";